
export type EntryVars = {
    secure:string;
    endpoint:string;
    testData: {},
    entryData: {}
}


export const getEntryVars = ():EntryVars => {
    // @ts-ignore
    return _entryVars as EntryVars;
}
